module.exports = __webpack_public_path__ + "img/sobre_pix1.43aa88d6.jpg";